var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-card",class:{ selected: _vm.selected },on:{"click":function($event){return _vm.$emit('click')}}},[_c('h4',[_vm._t("title")],2),(_vm.$slots.default)?_c('p',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }